<template>
<div class="inner">
	<div class="content">
		<div class="inner">
			<settings-manage />
			<settings-notifications-and-ui />
			<settings-logs
				:logs-users="logsUsers" :logs-response-msg="logsResponseMsg"
			/>
		</div>
	</div>
	<ul class="tabs">
		<button type="button" class="ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close" role="button" aria-disabled="false" title="close" aria-label="close">
			<span class="ui-button-icon-primary ui-icon ui-icon-closethick" />
		</button>
		<h3>Settings</h3>
		<li><a href="#account-settings">Account Management</a></li>
		<li><a href="#notification-settings">Notifications</a></li>
		<li><a href="#ui-settings">UI</a></li>
		<li><a href="#logs-settings">Logs</a></li>
	</ul>
</div>
</template>

<script>
import Logs from '../components/rph-logs.vue'
import Manage from '../components/rph-settings-manage.vue'
import NotificationsAndUi from '../components/rph-settings-notifications-and-ui.vue'

import { reactive, ref } from 'vue'
import $ from 'jquery'
import { db } from '../js/db.js'

export default {
	components: {
		'settings-logs': Logs,
		'settings-manage': Manage,
		'settings-notifications-and-ui': NotificationsAndUi
	},
	data: () => ({
		logsUsers: reactive({}),
		logsResponseMsg: ref( '' )
	}),
	mounted(){
		const $settingsDialog = $( this.$el ),
			thisVue = this

		$settingsDialog.find( '.tabs a' ).on( 'click', function( ev ){
			$settingsDialog.find( '.content .inner > div' ).hide()
			$settingsDialog.find( $( this ).attr( 'href' ) ).show()
			ev.preventDefault()
			switch ( $( this ).attr( 'href' ) ){
				case '#logs-settings':{
					db.msgs.orderBy( '[userid+otherid]' ).uniqueKeys( ( keysArray ) => {
						return keysArray
					}).then( ( pairsArray ) => {
						const countPromises = pairsArray.map( ( pair ) => {
							return db.msgs.where( '[userid+otherid]' ).equals( pair ).last().then( ( row ) => {
								return {userid: pair[0], otherid: pair[1], last: row.date}
							}).then( ( workingRow ) => {
								return db.msgs.where( '[userid+otherid]' ).equals( pair ).count().then( ( count ) => {
									workingRow.count = count
									return workingRow
								})
							})
						})
						return Promise.all( countPromises )
					}).then( ( rows ) => {
						const logsUsers = {}
						rows.forEach( ( row ) => {
							( logsUsers[row.userid] ? logsUsers[row.userid] : logsUsers[row.userid] = [] ).push( row )
						})
						thisVue.logsUsers = logsUsers
					})
						.catch( ( err ) => {
							console.log( err )
						})
						.finally( () => {
							if( thisVue.logsUsers.length === 0 ){
								thisVue.logsResponseMsg = 'You haven\'t made any private messages with anyone'
							}
						})
				}
				case '#account-settings':{
					socket.emit( 'get-transactions' )
				}
			}
		})

		$settingsDialog.find( '.ui-dialog-titlebar-close' ).on( 'click', function(){
			$settingsDialog.parent().hide()
			// clearInterval(hpsInterval);
		})
	}
}
</script>